import { ENUM_ActivityLogEntityType } from '@api-new/common/ENUM_ActivityLogEntityType';
import { InboxFilterModel } from '@shared/store/inbox/models/inbox-filter.model';

export const INBOX_FILTER: Record<InboxFilterModel, ENUM_ActivityLogEntityType[]> = {
  properties: [
    ENUM_ActivityLogEntityType.ACTIVITY_LOG_ENTITY_TYPE_PROPERTY,
    ENUM_ActivityLogEntityType.ACTIVITY_LOG_ENTITY_TYPE_PROPERTY_VALUE,
  ],
  mortgages: [
    ENUM_ActivityLogEntityType.ACTIVITY_LOG_ENTITY_TYPE_MORTGAGE,
    ENUM_ActivityLogEntityType.ACTIVITY_LOG_ENTITY_TYPE_MORTGAGE_PART,
    ENUM_ActivityLogEntityType.ACTIVITY_LOG_ENTITY_TYPE_MORTGAGE_PART_OVERPAYMENT,
    ENUM_ActivityLogEntityType.ACTIVITY_LOG_ENTITY_TYPE_MORTGAGE_PART_UNDERPAYMENT,
    ENUM_ActivityLogEntityType.ACTIVITY_LOG_ENTITY_TYPE_MORTGAGE_COMPARISON_SETTINGS,
  ],
  cases: [
    ENUM_ActivityLogEntityType.ACTIVITY_LOG_ENTITY_TYPE_MORTGAGE_CASE,
    ENUM_ActivityLogEntityType.ACTIVITY_LOG_ENTITY_TYPE_HELP_CASE,
    ENUM_ActivityLogEntityType.ACTIVITY_LOG_ENTITY_TYPE_SMART_SEARCH_CASE,
  ],
};

export const INBOX_FILTER_ALL: ENUM_ActivityLogEntityType[] = [
  ENUM_ActivityLogEntityType.ACTIVITY_LOG_ENTITY_TYPE_PROPERTY,
  ENUM_ActivityLogEntityType.ACTIVITY_LOG_ENTITY_TYPE_PROPERTY_VALUE,
  ENUM_ActivityLogEntityType.ACTIVITY_LOG_ENTITY_TYPE_MORTGAGE,
  ENUM_ActivityLogEntityType.ACTIVITY_LOG_ENTITY_TYPE_MORTGAGE_PART,
  ENUM_ActivityLogEntityType.ACTIVITY_LOG_ENTITY_TYPE_MORTGAGE_PART_OVERPAYMENT,
  ENUM_ActivityLogEntityType.ACTIVITY_LOG_ENTITY_TYPE_MORTGAGE_PART_UNDERPAYMENT,
  ENUM_ActivityLogEntityType.ACTIVITY_LOG_ENTITY_TYPE_MORTGAGE_COMPARISON_SETTINGS,
  ENUM_ActivityLogEntityType.ACTIVITY_LOG_ENTITY_TYPE_MORTGAGE_CASE,
  ENUM_ActivityLogEntityType.ACTIVITY_LOG_ENTITY_TYPE_HELP_CASE,
  ENUM_ActivityLogEntityType.ACTIVITY_LOG_ENTITY_TYPE_SMART_SEARCH_CASE,
];
